import { useRootState } from 'store/StateProvider';
import { useAPIMutation } from 'hooks/useAPIMutation';
import { SDFC_V1_BASE_URL } from 'views/constants';

export function usePostUploadCSVToSDFC() {
    const {
        deploymentConfig: {
            directorySvcResponse: { endpoint, protocol },
        },
        deploymentConfig: { envData },
    } = useRootState();

    const url = `${SDFC_V1_BASE_URL}/upload`;

    const mutation = useAPIMutation({
        key: ['exportToSFDC'],
        url,
        baseUrl: protocol ? `${protocol}://${endpoint}` : envData.MAINLINE_DEP0_API_GATEWAY_URL,
        suppressNotification: true,
    });
    return mutation;
}
